import emailConnection from './emailConnection';
import emailChannel from './emailChannel';
import emailBlacklist from './emailBlacklist';
import integration from './integration';
import tracking from './tracking';
import syncLog from './syncLog';
import bouncedEmail from './bouncedEmail';
import sendEmailConnection from './sendEmailConnection';
var TYPES = {
  emailChannel: emailChannel,
  emailConnection: emailConnection,
  emailBlacklist: emailBlacklist,
  tracking: tracking,
  integration: integration,
  syncLog: syncLog,
  bouncedEmail: bouncedEmail,
  sendEmailConnection: sendEmailConnection
};
export default TYPES;